var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1304 16.6H12.7304V15.4H12.1304V16.6ZM1 15.4H0.4V16.6H1V15.4ZM6.56572 11.8261L6.14147 12.2504L6.56575 12.6746L6.99 12.2503L6.56572 11.8261ZM12.1304 15.4H1V16.6H12.1304V15.4ZM7.16572 11.8261V0H5.96572V11.8261H7.16572ZM1.27152 7.38079L6.14147 12.2504L6.98996 11.4018L2.12002 6.53223L1.27152 7.38079ZM6.99 12.2503L11.8592 7.38076L11.0106 6.53227L6.14143 11.4018L6.99 12.2503Z",
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocDownloadIcon);
export default __webpack_public_path__ + "static/media/doc-download-icon.743eb7c264400f28fe5b8647e65db8bc.svg";
export { ForwardRef as ReactComponent };